import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useIntl } from "react-intl";

// Components
import { SidePanel, SidePanelHeader, SidePanelBody, SidePanelFooter, Button, Form, Select, Pill } from "@gpstrackit/gtc-react-controls"
import { NotificationManager } from 'Components/Notifications';

// Actions
import { getCoaches, openModalEditCoachPanel, updateDriverPerformanceCase } from './redux/slice'

// Styles
import './editCoachPanel.scss'

const EditCoachPanel = () => {

    const dispatch = useDispatch();
    const { messages } = useIntl();
    const { listCoaches = [], loading = false, open, dataToCase, loadingUpdate = false, error = null } = useSelector(state => state.driverPerformanceCasesTabEditCoachRedux || {});
    const [selectedCoach, setSelectedCoach] = useState("");

    useEffect(() => {
        if (open) {
            dispatch(getCoaches());
            setSelectedCoach(null); // Reset selected coach when modal opens
        }
    }, [open])

    useEffect(() => {
        // Preselect coach if case already has one and coaches list is available
        if (open && Array.isArray(listCoaches) && listCoaches.length && dataToCase?.coachId) {
            const preselectedCoach = listCoaches.find((coach) => String(coach?.id) === String(dataToCase?.coachId));
            if (preselectedCoach) {
                setSelectedCoach(preselectedCoach);
            }
        }
    }, [open, listCoaches, dataToCase?.coachId])

    const prevLoadingUpdateRef = useRef(false);

    useEffect(() => {
        const prevLoadingUpdate = prevLoadingUpdateRef.current;
        // Only notify when an update cycle finished: loadingUpdate true -> false
        if (prevLoadingUpdate && !loadingUpdate) {
            if (error) {
                NotificationManager.error(
                    error?.error || messages['errorMessage'],
                    messages['driver_performance_editCoachPanel_saveError'],
                    3000,
                    null,
                    null,
                    'error',
                );
            } else {
                NotificationManager.success(
                    messages['success'],
                    messages['driver_performance_editCoachPanel_saveSuccessfully'],
                    3000,
                    null,
                    null,
                    'success',
                );
            }
        }
        prevLoadingUpdateRef.current = loadingUpdate;
    }, [loadingUpdate, error])


    const handleSave = () => {
        if (selectedCoach && dataToCase?.id) {
            const payload = {
                id: dataToCase.id,
                coachId: selectedCoach.id,
                statusId: dataToCase?.statusId
            };
            dispatch(updateDriverPerformanceCase(payload));
        }
        dispatch(openModalEditCoachPanel({ open: false }));
        setSelectedCoach(null);
    }

    const handleCancel = () => {
        dispatch(openModalEditCoachPanel({ open: false }));
        setSelectedCoach(null);
    }

    const isSameCoachSelected = Boolean(selectedCoach) && String(selectedCoach.id) === String(dataToCase?.coachId);
    const isSaveDisabled = !selectedCoach || isSameCoachSelected;

    return (
        <SidePanel isOpen={open} onToggle={handleCancel} hiddenButton={true} style={{ width: '350px', transform: 'translateX(350px)' }}>
            <SidePanelHeader>
                <label className="edit-coach-panel__title">{messages['driver_performance_editCoachPanel_editCoachPanel_title']}</label>
            </SidePanelHeader>
            <SidePanelBody>
                <div className="edit-coach-panel__content">
                    <p>
                        <span>{messages['driver_performance_editCoachPanel_title_card_p1']}</span>
                        <span>{dataToCase?.driver?.name || ''}</span>
                        <span>{messages['driver_performance_editCoachPanel_title_card_p2']}</span>
                    </p>
                    <div className="edit-coach-panel__info-card">
                        <div className="edit-coach-panel__info-row">
                            <p>{messages['driver_performance_editCoachPanel_caseId']}</p>
                            <p>{dataToCase?.caseNumber || 'N/A'}</p>
                        </div>
                        <div className="edit-coach-panel__info-row" style={{ alignItems: 'center' }}>
                            <p>{messages['driver_performance_editCoachPanel_status']}</p>
                            <div style={{ width: 100 }} className="edit-casesTab-badge-status">
                                <Pill
                                    key={dataToCase?.statusId}
                                    item={{
                                        ...dataToCase.status,
                                        label: messages[`driver_performance_cases_status_${dataToCase?.status?.label?.toLowerCase()}`] || dataToCase?.status?.label,
                                        color: dataToCase?.status?.label === 'Pending' ? "grey" : dataToCase?.status?.label === 'Evaluate' ? "orange" : "#66bb6a"
                                    }}
                                    onClick={() => {

                                    }}
                                    variant={'outlined'}
                                    style={{ backgroundColor: `green !important` }}
                                />
                            </div>
                        </div>
                        {
                            dataToCase?.coach?.firstName || dataToCase?.coach?.lastName
                                ? (
                                    <div className="edit-coach-panel__info-row">
                                        <p>{messages['driver_performance_editCoachPanel_currentCoach']}</p>
                                        <p>{` ${dataToCase?.coach?.firstName || ''} ${dataToCase?.coach?.lastName || ''}`}</p>
                                    </div>
                                ) : (
                                    <div className="edit-coach-panel__info-row">
                                        <p>{messages['driver_performance_editCoachPanel_unassignedCoach']}</p>
                                    </div>
                                )
                        }
                    </div>
                </div>
                <Form>
                    <Select
                        id="coach"
                        label={messages['driver_performance_editCoachPanel_selectCoach']}
                        value={selectedCoach}
                        onChange={(value) => {
                            setSelectedCoach(value)
                        }}
                        options={listCoaches}
                        textField="fullname"
                        valueField="id"
                        placeholder={messages['driver_performance_editCoachPanel_selectCoach']}
                        isLoading={loading}
                        isSearchable={true}
                    />
                </Form>
            </SidePanelBody>
            <SidePanelFooter>
                <div className="edit-coach-panel__footer">
                    <Button variant="secondary" onClick={handleCancel}>{messages['driver_performance_editCoachPanel_cancel']}</Button>
                    <Button variant="primary" onClick={handleSave} isDisabled={isSaveDisabled}>{messages['driver_performance_editCoachPanel_save']}</Button>
                </div>
            </SidePanelFooter>
        </SidePanel>
    )
}

export default EditCoachPanel;